import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { callAPI, convertToUTCISOString, getFullName, getLocalValue, IsSmallScreen, LoacalVariables, Method } from "../../../commonFunctions/CommonFunctions";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { IMetaData } from "../../../Components/Dialog/WSCommonDialog";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent, storeDataComponent, updateDataComponent } from "../../../StateManagement/actions";
import DealPop from "../../Deals/DealPop";
import DealsDrawyer from "../../Deals/DealsDrawyer";
import dayjs from "dayjs";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";

export const OverViewDealsContact: React.FC<any> = React.memo((props) => {
  AllPermissions.getInstance();
  const { add, edit, remove, view } = AllPermissions.getDealPermission;
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch()
  const params = useParams();
  const id = params?.id;
  const [open, setOpen] = React.useState(false);
  const [dealListData, setdeallistData] = useState<any>([])
  const [resetLoad, setResetLoad] = useState(false)
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const resetTrigger = useSelector((state: any) => state.components?.leadContactDealsGrid?.resetTrigger);
  const [formComponent, setFormComponent] = useState<any>()
  const isMobile = IsSmallScreen();
  useEffect(() => {
    const getDeals = async () => {
      try {
        setResetLoad(false)
        const response: any = await callAPI(`deals/${id}/lead`, Method.GET, null, null);
        if (Array.isArray(response)) {
          const updatedDeals = response.map((item: any) => ({
            ...item,
            leadName: getFullName(item?.lead?.firstName, item?.lead?.lastName, ''),
          }));


          setdeallistData(updatedDeals);
        }

      }
      catch (e) {

      }
    }
    getDeals();
  }, [resetTrigger])
  useEffect(() => {

    const getDeals = async () => {
      try {
        setResetLoad(false)
        const response: any = await callAPI(`deals/${id}/lead`, Method.GET, null, null);
        if (Array.isArray(response)) {
          const updatedDeals = response.map((item: any) => ({
            ...item,
            leadName: getFullName(item?.lead?.firstName, item?.lead?.lastName, ''),
          }));

          setdeallistData(updatedDeals);
        }

      }
      catch (e) {

      }
    }
    getDeals();
  }, [resetLoad])
  const columns: IColumns[] = [
    {
      header: "Deal Name",
      fieldName: "dealName",
      tooltip: true,
      type: 'default'
    },
    {
      header: "Amount",
      fieldName: "amount",
      tooltip: true,
      type: 'default'
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),

    },
  ];
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {

      const form: any = <DealsDrawyer
        id={id}
        control={control}
        register={register}
        dealId={row.id}
        reset={reset}
        setValue={setValue}
        onCancel={() => { reset(); setOpen(false); setFormComponent(null) }}

      />
      setFormComponent(form)
      setTimeout(() => {
        setOpen(true)
      }, 10);
    }
  }
  const handleDealsData = async (data: any) => {
    try {
      dispatch(storeDataComponent('dealSubmit', { loading: true }));
      const response: any = await saveData(data);
      if (response && response?.message) {
        dispatch(resetDataComponent('leadContactDealsGrid'));
        setResetLoad(true)
        showMessage(response.message, response.success === true ? 'success' : 'error')
                reset()

      } else if (response?.id) {
        dispatch(resetDataComponent('leadContactDealsGrid'));
        setResetLoad(true)
        showMessage('Deals Created Successfully', 'success')
                reset()

      }
    } catch (e: any) {
      showMessage(e.error);
      setResetLoad(true)
    }
    finally {
      dispatch(updateDataComponent('dealSubmit', { loading: false }));
    }

  }
  const saveData = async (data: any) => {
    const formattedDateTime: any = dayjs(`${data?.closeDate} 00:00`, "DD-MM-YYYY HH:mm").toISOString();
    const request: any = {
      "dealName": data?.dealName || "",
      "amount": Number(data?.amount) || "",
      "stage": data?.stage || "",
      "status": data?.status || "",
      "closeDate": formattedDateTime || "",
      "leadId": id || "",
      "dealOwner": getLocalValue(LoacalVariables.UserId),
      "customerType": data?.customerType || "",
      "nextStep": data?.nextStep || "",
      "source": data?.source || "",
      "profitability": Number(data?.profitability) || 0,
      "expectedRevenue": Number(data?.expectedRevenue) || 0,
      "campaignSource": data?.campaignSource || "",
      "notes": data?.notes || "",
    }
    if (data?.dealId) {
      const response: any = await callAPI("deals", Method.PATCH, request, data?.dealId);
      return response
    } else {
      const response: any = await callAPI("deals", Method.POST, request);
      return response
    }

  }
  const handleDealsClick = () => {
    const form: any = <DealsDrawyer
      id={id}
      control={control}
      register={register}
      reset={reset}
      setValue={setValue}
      onCancel={() => { reset(); setOpen(false) }}

    />
    setFormComponent(form)
    setTimeout(() => {
      setOpen(true)
    }, 10);
  }

  return (
    <Grid
    >
      <Grid container spacing={2} sx={{ p: 0, borderRadius: 5 }}>
        {view ? <Grid item xs={12}>
          <WSDataGrid
            id="leadContactDealsGrid"
            title="Deals"
            data={dealListData}
            columns={columns}
            addButton={add ? { label: "New", color: "secondary" } : undefined}
            onAddButtonClick={handleDealsClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
          : <PermissionDenied title={'Deals'} />
        }
      </Grid>
      {formComponent && <SwipeableDrawerForm anchor="right" title={'Deals'} isMobile={isMobile}
        openForm={open}
        formComponent={<form onSubmit={handleSubmit(handleDealsData)}>
          {formComponent}
        </form>}
        onClose={() => { reset(); setOpen(false); setFormComponent(null) }}

      />}


    </Grid>
  );
});
